import { render } from "./QuizGame.vue?vue&type=template&id=3c967d67&scoped=true"
import script from "./QuizGame.vue?vue&type=script&lang=js"
export * from "./QuizGame.vue?vue&type=script&lang=js"

import "./QuizGame.vue?vue&type=style&index=0&id=3c967d67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c967d67"]])

export default __exports__